module.exports = __webpack_public_path__ + "img/edit.60da719.png";